export default "__VITE_ASSET__BldTB6vq__"